import { Sparkles, MapPin, Users } from "lucide-react";

const features = [
  { icon: Sparkles, text: "Wieloletnie doświadczenie sceniczne" },
  { icon: Users, text: "Występy dla firm i osób prywatnych" },
  { icon: MapPin, text: "Działamy na terenie całej Polski" },
];

export const About = () => {
  return (
    <section id="about" className="py-24 section-dark relative overflow-hidden">
      <div className="absolute inset-0 mesh-gradient opacity-50" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-space-grotesk font-bold text-center mb-4 text-foreground">
          O <span className="text-gradient">nas</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Poznaj nasz zespół profesjonalistów
        </p>

        <div className="max-w-4xl mx-auto glass-strong rounded-2xl p-8 md:p-12">
          <p className="text-lg mb-6 text-muted-foreground leading-relaxed">
            Jesteśmy zespołem profesjonalnych artystów z wieloletnim doświadczeniem scenicznym. 
            Specjalizujemy się w występach artystycznych dla firm i osób prywatnych, które 
            uświetniają każde wydarzenie i pozostają w pamięci na długo.
          </p>
          <p className="text-lg mb-8 text-muted-foreground leading-relaxed">
            Nasze występy są zawsze dopasowane do charakteru wydarzenia i potrzeb klienta. 
            Łączymy profesjonalizm z kreatywnością, tworząc niezapomniane show.
          </p>

          <div className="grid sm:grid-cols-3 gap-4">
            {features.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.text} className="flex items-center gap-3 p-4 rounded-xl bg-secondary/50">
                  <Icon className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="text-sm text-foreground">{f.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
